import { HttpClient } from '@angular/common/http';
import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { Configuration } from 'src/app/enum/Configuration';
import { ActiveUserStorage } from 'src/app/services/active-user-storage.service';
import { DrawerService } from 'src/app/services/drawer.service';
import { SharedDataService } from 'src/app/services/shared-data-service.service';
import { UserSessionService } from 'src/app/services/usersession.service';
@Component({
  selector: 'app-drawer',
  templateUrl: './drawer.component.html',
  styleUrls: ['./drawer.component.scss']
})
export class DrawerComponent implements OnInit {
  isDrawerOpen = false;
  @Input() isOpen: boolean;
  @Input() content: boolean;
  @Input() content2: any[];


  message: any

  constructor(public drawerService: DrawerService, public activeUserStorage: ActiveUserStorage, public sharedDataService: SharedDataService, private http: HttpClient,
      private sessionService: UserSessionService
  ) {  }
 

  ngOnInit(): void {

    if (this.isOpen) {
        debugger
        this.drawerService.drawerOpen$.subscribe(async isOpen => {
            debugger
            if (this.isOpen) {
                debugger
                        this.isDrawerOpen = isOpen;
                        document.body.style.overflow = isOpen ? 'hidden' : 'auto';
            }
        });
    }
  }

}
